"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useAutocomplete.default;
  }
});
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function get() {
    return _useAutocomplete.createFilterOptions;
  }
});

var _useAutocomplete = _interopRequireWildcard(require("./useAutocomplete"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/useAutocomplete/index.js
// module id = 787
// module chunks = 0